import React, { useState, useEffect } from "react";
import Header from "../../commons/header/header";
import About from "../../commons/homeAbout/about";
import Footer from "../../commons/footer/footer";
import Department from "../../commons/homeDepartments/departments";
import Section from "../../commons/header/sectionimage";
import Notification from "../../commons/notification/notification";
import LandingModal from "../../posterModal/modal"; // Import the new modal
import "./home.css";

const Home = () => {
  const [isPosterOpen, setIsPosterOpen] = useState(false);

  useEffect(() => {
    const hasSeenPoster = sessionStorage.getItem("hasSeenPoster");
    if (!hasSeenPoster) {
      setIsPosterOpen(true);
      sessionStorage.setItem("hasSeenPoster", "true");
    }
  }, []);

  const handlePosterClose = () => {
    setIsPosterOpen(false);
  };

  return (
    <>
      <LandingModal open={isPosterOpen} handleClose={handlePosterClose} />
      <Header />
      <div className="home">
        <Section />
        <Notification />
        <div className="my-4">
          <About />
        </div>
        <div className="my-4">
          <Department />
        </div>
        <div className="my-4">
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Home;